export default function Social() {
    return (
      <div className="socials-page">
        <div className="flex-center">
          <a href="https://t.me/EagleEye_Token" target="_blank">
            <i className="fa fa-telegram fa-4x icon-3d"></i>
          </a>
          <a href="https://www.reddit.com/r/EagleEyeToken/" target="_blank">
            <i className="fa fa-reddit fa-4x icon-3d"></i>
          </a>
          <a href="https://www.youtube.com/channel/UCtqnqcLzRMY3g-nPve9r0QA" target="_blank">
            <i className="fa fa-youtube fa-4x icon-3d"></i>
          </a>
          {/* <a href="https://twitter.com/EagleEye_Token" target="_blank">
            {" "}
            <i
              style={{ padding: "0", height: "6%", width: "9%" }}
              className="fa fa-tiktok fa-4x icon-3d"
            >
              <TIKTOK style={{ height: "6%", width: "12%" }} />
            </i>
          </a> */}
        </div>
  
        <div className="flex-center">
          <a href="https://twitter.com/EagleEye_Token" target="_blank">
            <i className="fa fa-twitter fa-4x icon-3d"></i>
          </a>
          {/* <a href="https://twitter.com/EagleEye_Token" target="_blank">
         
            <i className="fa fa-facebook fa-4x icon-3d"></i>
          </a> */}
          <a href="https://www.instagram.com/EagleEye_token/" target="_blank">
           
            <i className="fa fa-instagram fa-4x icon-3d"></i>
          </a>
          <a href="https://twitter.com/EagleEye_Token" target="_blank" style={{color: "white",  margin: '0 0rem 0 1rem', textDecoration: 'underline'}}>
           
            Tik Tok
          </a>
          <a href="https://twitter.com/EagleEye_Token" target="_blank" style={{color: "white", margin: '0 0rem 0 1rem', textDecoration: 'underline'}}>
           
            Article
          </a>
        </div>
      </div>
    );
  }